module.exports = __webpack_public_path__ + "img/LogisticaImportacion.96924749.svg";